import {
  FormControl,
  MenuItem,
  SelectProps,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { SelectFieldContainer } from './select-field.styles'
import DropdownArrow from '../../assets/icons/DropdownArrow.png'
import { Controller, useFormContext } from 'react-hook-form'

export type Option = { label: string; value: string }

type SelectDriverProps = {
  options: Option[]
  hideLabel?: boolean
  labeldirection?: 'row' | 'column'
  label?: string
  required?: boolean
} & SelectProps

const SelectField = ({
  name,
  options,
  label,
  labeldirection = 'row',
  hideLabel = false,
  required = false,
  fullWidth,
  style,
  sx,
  ...rest
}: SelectDriverProps) => {
  const theme = useTheme()
  const { control } = useFormContext()

  return (
    <Stack direction={labeldirection} alignItems="center" spacing={2}>
      {!hideLabel && (
        <Typography
          sx={{
            color: required ? '#000' : undefined,
            fontWeight: required ? 500 : 300,
            width: labeldirection === 'column' ? '100%' : 'auto',
          }}
        >
          {label}
        </Typography>
      )}
      <Controller
        name={name ?? ''}
        control={control}
        render={({ field: { onChange, value } }) => (
          <FormControl sx={{ width: fullWidth ? '100%' : 'auto' }}>
            <SelectFieldContainer
              labelId="select-field"
              id="select-field"
              value={value}
              size="small"
              onChange={onChange}
              theme={theme}
              sx={{
                color: 'common.white',
                fontWeight: 700,
                borderRadius: '6px',
                ...sx,
              }}
              IconComponent={() => (
                <img
                  src={DropdownArrow}
                  alt="dropdown arrow"
                  width={19}
                  height={13}
                  style={{ marginRight: '10px' }}
                />
              )}
              style={style}
              {...rest}
            >
              {!!label && <MenuItem value={label}>{label}</MenuItem>}
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </SelectFieldContainer>
          </FormControl>
        )}
      />
    </Stack>
  )
}

export default SelectField
